import { Divider, Paper, Typography } from "@mui/material";
import BasicServiceItem from "./components/BasicServiceItem";

const BasicQuoteContent = ({ service }) => {
  console.log("[BasicQuoteContent] received service:", service);
  return (
    <Paper
      elevation={0}
      sx={{
        p: 1.5,
        mb: 2,
        borderRadius: 2,
        backgroundColor: "var(--fx-surface-base, #FFFFFF)",
      }}
    >
      <BasicServiceItem service={service} />
    </Paper>
  );
};

export default BasicQuoteContent;
